/**
 * Utility to check if the current URL matches sales page patterns
 */

const SALES_PAGE_PATTERNS = [
  '/neufs/',
  '/new/',
  '/occasion/',
  '/used/',
  '/demos/',
  '/demonstrateurs/',
  'promotions',
  'finance',
  'inventaire',
  'inventory',
  '/configuration-et-prix/',
  '/build-and-price/',
  '/requests/',
  '/demandes/'
];

// URL patterns that map to specific L1 menu categories
const NEW_VEHICLE_PATTERNS = ['/new/', '/neufs/'];
const USED_VEHICLE_PATTERNS = ['/used/', '/occasion/'];

/**
 * Detect which L1 category the current URL matches for auto-skip.
 * Returns 'new', 'used', or null if no match.
 */
export function detectAutoSkipCategory(): 'new' | 'used' | null {
  const currentUrl = window.location.href.toLowerCase();
  
  if (NEW_VEHICLE_PATTERNS.some(p => currentUrl.includes(p))) {
    return 'new';
  }
  if (USED_VEHICLE_PATTERNS.some(p => currentUrl.includes(p))) {
    return 'used';
  }
  return null;
}

// L1 titles that correspond to each category (EN and FR variants)
// Uses accent-stripped comparison at match time, so accented variants are optional
export const AUTO_SKIP_TITLE_MAP: Record<string, string[]> = {
  new: ['New', 'Neuf'],
  used: ['Used', 'Usag\u00e9', 'Usage', 'VUS'],
};

/**
 * Check if the current URL contains any sales page pattern
 */
export function isSalesPage(): boolean {
  const currentUrl = window.location.href.toLowerCase();
  
  return SALES_PAGE_PATTERNS.some(pattern => 
    currentUrl.includes(pattern.toLowerCase())
  );
}

/**
 * Check if chat should be loaded based on sales_pages_only flag
 */
export function shouldLoadChat(salesPagesOnly: boolean): boolean {
  // If sales_pages_only is false, always load chat
  if (!salesPagesOnly) {
    return true;
  }
  
  // If sales_pages_only is true, only load on sales pages
  return isSalesPage();
}
